module.exports = __webpack_public_path__ + "static/media/colorShadowGirl.54a4ce70.jpg";